module.exports = __webpack_public_path__ + "static/HelveticaNeueLTW1G-Roman-a0d7c6925f84f0df9c533e420d851262.ttf";